import type { LoaderFunctionArgs } from '~/types/route-args';
import type { ShouldRevalidateFunction } from 'react-router';
import { data as routerData } from 'react-router';
import { getBrandsByCategory } from '@modules-rocco/professionals/api/get-brands-by-category.server';

export const BRANDS_BY_CATEGORY_ACTION = '/actions/brands-by-category';

/**
 * API endpoint to fetch brands (professionals) for the Browse by Brand section.
 * Accepts a categoryLink query parameter and returns featured brands plus
 * auto-fetched regular brands. Results benefit from the LRU cache in getBrandsByCategory.
 */
export const loader = async ({ request, context }: LoaderFunctionArgs) => {
    const { logger } = context;
    const url = new URL(request.url);
    const rawCategoryLink = url.searchParams.get('categoryLink');

    // Validate categoryLink format: must start with /products and contain only valid path chars
    if (
        rawCategoryLink &&
        !/^\/products(\/[a-z0-9-]+)*$/.test(rawCategoryLink)
    ) {
        return routerData({ brands: [], featuredCount: 0 }, { status: 400 });
    }

    const categoryLink = rawCategoryLink || undefined;

    try {
        const result = await getBrandsByCategory({ categoryLink }, context);
        return result;
    } catch (error) {
        logger.error('Error in /actions/brands-by-category', { error });
        return routerData({ brands: [], featuredCount: 0 }, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    return false;
};
